import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Backdrop from '@material-ui/core/Backdrop'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import clsx from 'clsx'

import { t } from 'i18n'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1
  },
  padding: {
    padding: theme.spacing(5)
  },
  icon: {
    marginBottom: theme.spacing(1)
  },
  fullScreenIcon: {
    marginRight: theme.spacing(2)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 2,
    color: theme.palette.common.black
  },
  translucentBackground: {
    background: 'rgba(0,0,0,0.5)'
  }
}))

interface LoadingProps {
  fullScreen?: boolean
  size?: number
  showLabel?: boolean
  padding?: boolean
  translucentBackdrop?: boolean
  labelText?: string
}

const Loading: React.FC<LoadingProps> = ({
  fullScreen,
  size,
  showLabel = true,
  padding = true,
  translucentBackdrop = false,
  labelText = t('loading')
}) => {
  const classes = useStyles()

  if (fullScreen) {
    return (
      <Backdrop className={clsx(classes.backdrop, { [classes.translucentBackground]: translucentBackdrop })} open>
        {labelText}
      </Backdrop>
    )
  } else {
    return (
      <div className={clsx(classes.root, { [classes.padding]: padding })}>
        <CircularProgress color='inherit' className={classes.icon} size={size ?? 40} />
        {showLabel && <Typography variant='h6'>{labelText}</Typography>}
      </div>
    )
  }
}

export default Loading
